import script from "./ThinkTankIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ThinkTankIndex.vue?vue&type=script&setup=true&lang=js"

import "./ThinkTankIndex.vue?vue&type=style&index=0&id=36bbce9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bbce9a"]])

export default __exports__